import { IProcessRexEventRequest, IProcessRexEventResponse, ProcessRexEvent } from '../contracts';
import axios from 'axios';
import LogCannon from '@ace-clublabs/log-cannon';
import { createAxiosConfig } from '../mockHelper';

export const ProcessRexEventApi =
  (endpoint: string): ProcessRexEvent =>
  async (request: IProcessRexEventRequest): Promise<IProcessRexEventResponse> => {
    try {
      const config = { ...createAxiosConfig(null, endpoint) };
      const response = await axios.post(endpoint, request, config);
      LogCannon.blast('ProcessRexEventApi success');
      return Promise.resolve(response?.data);
    } catch (e) {
      LogCannon.warn('ProcessRexEventApi error', e as any);
      return { status: 'error' };
    }
  };
